export default __webpack_public_path__ + "static/media/cross_bite.eef15460.png";